var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderstandMyBillPublicPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54 37.051V35a2 2 0 0 0-2-2h-1v-4.841a10 10 0 1 0-8 0V33h-1a2 2 0 0 0-2 2v2h-3a1 1 0 0 1-1-1V2a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v5h-6a3 3 0 0 0-2.816 2H12a1 1 0 0 1-1-1V2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v8a7.008 7.008 0 0 0 7 7h9.184A3 3 0 0 0 22 19h6v17a1 1 0 0 1-1 1h-5v-3a3 3 0 0 0-2-2.816V27h3a3 3 0 0 0 0-6h-4.184a2.982 2.982 0 0 0-5.632 0H9a3 3 0 0 0 0 6h3v4.184A3 3 0 0 0 10 34v3.051A10.013 10.013 0 0 0 1 47v15a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V49a4 4 0 0 1 4-4h38a4 4 0 0 1 4 4v13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V47a10.013 10.013 0 0 0-9-9.949ZM39 19a8 8 0 1 1 8 8 8.009 8.009 0 0 1-8-8Zm6 9.8a10 10 0 0 0 4 0V33h-4ZM42 35h10v2H42ZM5 10V3h4v5a3 3 0 0 0 3 3h7v4h-9a5.006 5.006 0 0 1-5-5Zm17 7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h6v8Zm2 7a1 1 0 0 1-1 1h-4v-2h4a1 1 0 0 1 1 1Zm-8-3a1 1 0 0 1 1 1v3h-2v-3a1 1 0 0 1 1-1Zm-8 3a1 1 0 0 1 1-1h4v2H9a1 1 0 0 1-1-1Zm10 3v4h-4v-4Zm-5 6h6a1 1 0 0 1 1 1v3h-8v-3a1 1 0 0 1 1-1Zm48 28h-4V49a6.006 6.006 0 0 0-6-6H13a6.006 6.006 0 0 0-6 6v12H3V47a8.009 8.009 0 0 1 8-8h16a3 3 0 0 0 3-3V3h4v33a3 3 0 0 0 3 3h16a8.009 8.009 0 0 1 8 8Z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 19a6 6 0 1 0-6 6 6.006 6.006 0 0 0 6-6Zm-10 0a4 4 0 1 1 4 4 4 4 0 0 1-4-4Z",
    fill: "#00206d",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderstandMyBillPublicPurchase);
export default __webpack_public_path__ + "static/media/understandMyBill-publicPurchase.bb61b5410e45c460d927df308c4f4c50.svg";
export { ForwardRef as ReactComponent };